import get from 'lodash-es/get';

export const getIsoCode = country => {
  const code = get(country, 'isoA2Code');
  return code === 'uk' ? 'gb' : code;
};
